import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { ContractDownloadComponent } from "./components/contract-download/contract-download.component";
import { LoginComponent } from "./components/login/login.component";
import { OkSignSuccessComponent } from "./components/ok-sign-success/ok-sign-success.component";
import { AuthGuard } from "./guards/auth.guard";
import { DelegationSelectorGuard } from "./guards/delegation-selector.guard";
import { AzuressoComponent } from "./components/integrations/azuresso/azuresso.component";
import { NavigationEnum } from "./enums/navigation.enum";

const routes: Routes = [
  {
    path: "azuresso/callback",
    component: AzuressoComponent
  },
  {
    // before the dashboard route, so the selector never loads the dashboard
    path: NavigationEnum.DelegationSelector,
    canActivate: [DelegationSelectorGuard],
    loadChildren: () => import("./delegation/delegation.module").then(m => m.DelegationModule)
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () => import("./dashboard/dashboard.module").then(m => m.DashboardModule)
  },
  {
    path: "ok-sign-success",
    component: OkSignSuccessComponent
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "forgot",
    component: LoginComponent
  },
  {
    path: "reset/:id",
    component: LoginComponent
  },
  {
    path: "contract-download/:id",
    component: ContractDownloadComponent
  },
  {
    path: "**",
    redirectTo: "login",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
